import React, { useContext, useMemo } from 'react';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { CommonDataContext } from 'contexts/CommonDataContext';
import { CardBackground } from 'components/CardBackground/CardBackground';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { getUserManagementTabs } from '../../../constants';
import { UserManagementTab } from '../../../types';

export const UserManagementPage = () => {
  const { isDealerUser, isSuperAdminOrSingleAccount } = useContext(CommonDataContext);

  const tabs = useMemo(
    () => getUserManagementTabs(isDealerUser, isSuperAdminOrSingleAccount),
    [isDealerUser, isSuperAdminOrSingleAccount]
  );

  return (
    <PageContainer>
      <CardContainer style={{ padding: '0.5rem' }}>
        <TabsContainer<UserManagementTab> tabs={tabs} isSyncWithAnchor TabsLabelWrapper={CardBackground} />
      </CardContainer>
    </PageContainer>
  );
};
